import {
  CampaignFilter,
  CampaignsWithCampaignComponentsQuery,
  CampaignsWithCampaignComponentsQueryVariables,
  CampaignsWithCampaignComponentsQuery as CampaignsWithCampaignComponentsQueryApollo,
  OfferFilter,
} from '@occc/graphql';
import { useGetCampaignsWithCampaignComponents as useGetCampaignsWithCampaignComponentsQuery } from '@occc-app/dataAccessLayer/campaign/queries';
import { QueryHookOptions } from '@apollo/client';
import { PaginationInfo } from '@occc-app/hooks/usePaginatedQuery';

import {
  CampaignComponentSanitized,
  CampaignWithCampaignComponentsSanitized,
} from '../../CampaignListPage/types';

const transformDataToCampaignsArray = (
  data: CampaignsWithCampaignComponentsQuery,
): CampaignWithCampaignComponentsSanitized[] =>
  data.campaigns.edges.map(
    ({ node: { uuid, name, description, category, externalId, deleted, offers } }) => {
      const sanitizedCampaignComponents: CampaignComponentSanitized[] | undefined =
        offers?.edges.map(
          ({ node }): CampaignComponentSanitized => ({
            id: node.id,
            name: node.name,
            deleted: node.deleted,
            externalId: node.externalId,
            description: node.description,
            category: node.category,
          }),
        );

      return {
        uuid,
        name,
        description,
        category,
        externalId,
        deleted,
        campaignComponents: sanitizedCampaignComponents || null,
      };
    },
  );

type GetCampaignsWithCampaignComponentsArgs = {
  campaignFilter: CampaignFilter;
  offerFilter?: OfferFilter;
  pageSize?: number;
  baseOptions?: QueryHookOptions<
    CampaignsWithCampaignComponentsQueryApollo,
    CampaignsWithCampaignComponentsQueryVariables
  >;
  paginationInfo?: PaginationInfo;
  onPageChange?: (info: PaginationInfo) => void;
};

export const useGetCampaignsWithCampaignComponents = (
  args: GetCampaignsWithCampaignComponentsArgs,
) => {
  const response = useGetCampaignsWithCampaignComponentsQuery(args);

  return {
    ...response,
    data: response.data ? transformDataToCampaignsArray(response.data) : response.data,
  };
};
